var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 65 65",
    width: "65pt",
    height: "65pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_G5L5xVAkEyRhTXXzopFMML8Gf4SUBlr6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_G5L5xVAkEyRhTXXzopFMML8Gf4SUBlr6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.822,
    y: 14.822,
    width: 35.355,
    height: 35.355,
    transform: "matrix(0.707,-0.707,0.707,0.707,-13.462,32.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArticle);
export default __webpack_public_path__ + "static/media/IconArticle.7fce006ede81f858b858cf65c7d17103.svg";
export { ForwardRef as ReactComponent };